import qs from 'qs';  
import axios from "axios";

class Functions {
  route   = null;
  router  = null;
  store   = null;
  api     = null;
  shipper = null;

  constructor(router, store, cookies) {
    this.router  = router;
    this.store   = store;
    this.cookies = cookies;

    this.api = axios.create({
      baseURL: 'https://ica.iset.com.br/activation',
      timeout: 120000,      
    });    

    this.logger = axios.create({
      baseURL: 'https://ica.iset.com.br/activation',
      timeout: 10000,
    });    

    this.tracking = axios.create({
      baseURL: 'https://ica.iset.com.br/activation',
      timeout: 10000,
    });    

    this.shipper = axios.create({
      baseURL: 'https://shipper-sandbox.endpoint.directory/v1/address/br/',
      timeout: 10000,      
    });
  }
  
  setRoute(route){ this.route = route; }
  
  debug(s){
    if (this.store.state.debug){
      console.log(s);
    }
  }

  debugStoreState(){
    this.debug('Functions => debugStoreState');
    this.debug('========== SESSION ==========');
    this.debug(this.store.state.session);
    this.debug('========== PASSWORD ==========');
    this.debug(this.store.state.password);
    this.debug('========== CLIENT ==========');
    this.debug(this.store.state.client);
    this.debug('========== BUSINESS ==========');
    this.debug(this.store.state.business);
    this.debug('========== ADDRESS ==========');
    this.debug(this.store.state.address);
    this.debug('========== DOMAIN ==========');
    this.debug(this.store.state.domain);
    this.debug('========== PLAN ==========');
    this.debug(this.store.state.plan);
    this.debug('========== ORDER ==========');
    this.debug(this.store.state.order);
    this.debug('========== INVOICE ==========');
    this.debug(this.store.state.invoice);
    this.debug('========== HOSTING ==========');
    this.debug(this.store.state.hosting);
    this.debug('========== ECOMMERCE ==========');
    this.debug(this.store.state.ecommerce);
    this.validateLogin().then((res) => { this.debug("Is Logged in: " + res);});    
    this.loadPlanGroup();
  }

  async get(action, params, endpoint){
    this.debug('Functions => get');
    const requestHeaders = {headers: { 'action': action} };

    try {
      const request = await this.api.get('/ist_'+endpoint+'?'+qs.stringify(params), requestHeaders);
      this.debug(request);
      return request.data;
    } 
    catch (error) {
      this.debug('ERROR: ' + error);
      return error;
    }
  }

  async post(action, params, endpoint){
    // endpoint = 'teste.php';    
    this.debug('Functions => post');    

    let strParams = params;

    if (action != 'createUser'){
      strParams = JSON.stringify(params);
      strParams = strParams.replaceAll('"', '');
      strParams = strParams.replaceAll(' ', '');
    }

    //Get timestamp rounded by 60 seconds
    var timestamp = Math.floor(Date.now() / 3600000) * 3600;
    let token = await this.hash(strParams+ "m0d4F0c4"+timestamp);

    this.debug("### POST PARAMS ###");
    this.debug("### params ###");
    this.debug(params);
    this.debug("### qs.stringify(params) ###");
    this.debug(qs.stringify(params));
    this.debug("### strParams ###");
    this.debug(strParams);
    this.debug("### token ###");
    this.debug(token);

    const requestHeaders = {headers: { 'action': action, 'token': token} };

    try {
      const request = await this.api.post('/ist_'+endpoint, qs.stringify(params), requestHeaders);
      this.debug(request);
      return request.data;
    }
    catch (error) {
      this.debug('ERROR: ' + error);
      return error;
    }
  }
  
  async hash(string) {
    const utf8 = new TextEncoder().encode(string);
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, '0'))
      .join('');
    return hashHex;
  }

  async getIPAddress(){
    try {
      const request = await fetch('https://api.ipify.org?format=json');
      const response = await request.json();
      const ipAddress = response.ip;
      
      this.debug('Functions => getIPAddress: ' + ipAddress);
      this.store.commit('session', ['ipAddress', ipAddress]);

    } catch (error) {
      this.debug('ERROR: ' + error);
      return error;
    }
  }

  async getAddress(CEP){
    this.debug('Functions => getAddress');

    try {
      const request = await this.shipper.get(CEP);
      this.debug(request.data);
      return request.data;
    } 
    catch (error) {
      this.debug('ERROR: ' + error);
      return error;
    }
  }

  async loadPlanGroup(){
    this.debug('Functions => loadPlanGroup');

    if (!this.store.state.session.gid){
      this.store.commit('session', ['groupTitle', '']);
      return;
    }
    
    const params = {'gid': this.store.state.session.gid};

    const response = await this.post('checkPlanGroup', params, 'login.php');
    this.debug(response);

    if (response.result == 'success'){
      this.store.commit('session', ['groupTitle', response.title]);
    } else {
      this.store.commit('session', ['gid', '']);
      this.store.commit('session', ['groupTitle', '']);
    }
  }

  async validateLogin(){
    this.debug('Functions => validateLogin');
    if (!this.store.state.client.email)
      this.store.commit('client', ['email', this.store.state.session.email]);

    const params = {'email': this.store.state.client.email, 'password': this.store.state.client.password, 'token': this.store.state.session.token};
    const response = await this.post('validateLogin', params, 'login.php');
    return (response.result == 'success');
  }

  async doLogin(email, password, token = null){
    this.debug('Functions => doLogin('+email+', '+password+', '+token+')');

    this.store.commit('client', ['loggedIn', false]);

    if (!email || (!password && !token)) return false;

    const params = {'email': email, 'password': password, 'token': token};
    const response = await this.post('validateLogin', params, 'login.php');

    if (response.result == 'success'){
      this.debug("===== LOGIN RESPONSE =====");
      this.debug(response);

      this.store.commit('client', ['id', response.login.userid]);
      this.store.commit('client', ['email', email]);
      this.store.commit('client', ['firstName', response.client.firstname]);
      this.store.commit('client', ['lastName', response.client.lastname]);
      this.store.commit('client', ['phone', response.client.phonenumber]);
      this.store.commit('client', ['loggedIn', true]);

      //PRECISO TRAZER DOCTYPE CPF / CNPJ
      this.store.commit('business', ['company', response.client.companyname]);      
      this.store.commit('address',  ['city', response.client.city]);      
      this.store.commit('address',  ['state', response.client.state]);      

      this.store.commit('session', ['email', email]);
      this.store.commit('session', ['token', response.login.passwordhash]);

      if (!this.store.state.session.gid){
        this.store.commit('session', ['gid', response.client.plangroup.gid]);
        this.store.commit('session', ['groupTitle', response.client.plangroup.title]);
      }

      this.store.commit('password', password);
      
      this.saveCookie('session');
      this.saveCookie('client');
      this.saveCookie('business');
      this.saveCookie('address');
      this.saveCookie('plan');
            
      return true;
    } else {
      this.store.commit('session', ['email', email]);      
      this.saveCookie('session');

      return false;
    }
  }

  validateEmail(email){
    if (!email) return;

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  async loadQueryString(){
    this.debug('Functions => loadQueryString');

    //Get Email
    const email = this.route.query.email;
    if (email && this.validateEmail(email)) this.store.commit('session', ['email', email]);
    
    //Get Affiliate ID
    const affid = parseInt(this.route.query.affid);
    if (Number.isInteger(affid) && affid > 0) this.store.commit('session', ['affid', affid]);

    //Get UTM
    const utm_source = this.route.query.utm_source;
    if(utm_source) this.store.commit('session', ['utm_source', utm_source]);
    const utm_medium = this.route.query.utm_medium;
    if (utm_medium) this.store.commit('session', ['utm_medium', utm_medium]);
    const utm_campaign = this.route.query.utm_campaign;
    if (utm_campaign) this.store.commit('session', ['utm_campaign', utm_campaign]);

    //Get COUPON
    const coupon = this.route.query.coupon;
    if (coupon) this.store.commit('session', ['coupon', coupon]);

    //Get GROUP ID e PLAN ID
    const gid = parseInt(this.route.query.gid);
    if (Number.isInteger(gid)) this.store.commit('session', ['gid', gid]);
    const pid = parseInt(this.route.query.pid);
    if (Number.isInteger(pid)) this.store.commit('session', ['pid', pid]);

    //Get CYCLE
    const cycle = this.route.query.cycle;
    this.store.commit('session', ['cycle', cycle ? cycle : 'monthly']);

    await this.saveCookie('session');
  }

  //========== COOKIE HANDLING ==========//
  async saveCookie(model, finished = false){
    this.debug('Functions => saveCookie: ' + model);

    try{
      const modelData = JSON.parse(JSON.stringify(this.store.state[model]));
      
      let cookieLife = model == 'session' ? '30d' : '7d';
      if (finished) cookieLife = '30d';

      const cookieDomain = this.store.state.debug ? '' : '.iset.com.br';
      const cookieSecure = !this.store.state.debug;

      this.cookies.config(cookieLife,'',cookieDomain,cookieSecure);
      this.cookies.set("iset-"+model, modelData);      
    } catch (error) {
      this.debug('ERROR: ' + error);
    }
  }

  async loadCookie(model){
    this.debug('Functions => loadCookie: ' + model);

    let modelData = this.cookies.get("iset-"+model);
    this.debug(modelData);

    if (modelData){
      try{
        for (var [key, value] of Object.entries(modelData)) {        
          if (this.store.state[model][key] == "" || this.store.state[model][key] == 0 || this.store.state[model][key] == null){
            this.debug('Updating model: ' + model +"["+ key +"] = "+ value);
            this.store.commit(model, [key, value]);
          }
        }
      } catch (error) {
        this.debug('ERROR: ' + error);
      }
    }
  }

  async loadWHMCSAffiliateID(){
    this.debug('Functions => loadWHMCSAffiliateID');

    let WHMCSAffiliateID = parseInt(this.cookies.get("WHMCSAffiliateID"));
    
    if (Number.isInteger(WHMCSAffiliateID) && WHMCSAffiliateID > 0){
      this.debug("WHMCSAffiliateID = " + WHMCSAffiliateID);
      this.store.commit('session', ['affid', WHMCSAffiliateID]);
    } else this.debug("WHMCSAffiliateID not set");
  }

  async resetAll(){
    await this.resetData();
    await this.resetSession();
    this.closeInfo();
  }

  async resetSession(){
    this.store.commit('loading');

    this.store.commit('session', ['id', '']);
    this.store.commit('session', ['email', '']);
    this.store.commit('session', ['token', '']);
    this.store.commit('session', ['ipAddress', '']);
    this.store.commit('session', ['gid', '']);
    this.store.commit('session', ['groupTitle', '']);
    this.store.commit('session', ['pid', '']);
    this.store.commit('session', ['cycle', '']);
    this.store.commit('password', '');

    await this.saveCookie('session');
    
    this.store.commit('loaded');
  }

  async resetData(){
    this.debug("Functions => resetData");

    this.store.commit('loading');

    for (var [key, value] of Object.entries(this.store.state.client)) {      
      this.store.commit('client', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.business)) {      
      this.store.commit('business', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.address)) {      
      this.store.commit('address', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.domain)) {      
      this.store.commit('domain', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.plan)) {      
      this.store.commit('plan', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.order)) {      
      this.store.commit('order', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.invoice)) {      
      this.store.commit('invoice', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.hosting)) {      
      this.store.commit('hosting', [key, '']);
    }
    for (var [key, value] of Object.entries(this.store.state.ecommerce)) {      
      this.store.commit('ecommerce', [key, '']);
    }

    await this.saveCookie('client');
    await this.saveCookie('business');
    await this.saveCookie('address');
    await this.saveCookie('domain');
    await this.saveCookie('plan');
    await this.saveCookie('order');
    await this.saveCookie('invoice');
    await this.saveCookie('hosting');
    await this.saveCookie('ecommerce');

    this.store.commit('loaded');
  }

  validateCPF(strCPF) {
    let cleanCPF = strCPF.replace(/\D+/g, '');
    let Soma;
    let Resto;
    Soma = 0;
  if (cleanCPF == "00000000000") return false;

  for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(cleanCPF.substring(i-1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(cleanCPF.substring(9, 10)) ) return false;

  Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(cleanCPF.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(cleanCPF.substring(10, 11) ) ) return false;
    return true;
  }

  validateCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g,'');

    if(cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" || 
        cnpj == "11111111111111" || 
        cnpj == "22222222222222" || 
        cnpj == "33333333333333" || 
        cnpj == "44444444444444" || 
        cnpj == "55555555555555" || 
        cnpj == "66666666666666" || 
        cnpj == "77777777777777" || 
        cnpj == "88888888888888" || 
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;

    return true;      
  }  

  currencyFormat(value, precision = 0){    
    if (value){
      value = parseInt(value);
      return value.toLocaleString('pt-BR', { minimumFractionDigits: precision, maximumFractionDigits: precision });
    }
    else return 0;
  }


  async checkAffiliate(affid){
    this.debug('Functions => checkAffiliate');
    this.store.commit('loader', [true, "Aguarde", "Verificando Afiliado..."]);
    
    const params = {'affid': affid };

    this.get('checkAffiliate', params, 'plan.php').then((response) => {
      this.debug(response);
      if (response.result == 'success'){          
        this.store.commit('order', ['affid', response.id]);
        this.store.commit('order', ['affName', response.name]);        
      }
      this.store.commit('loader', []);
    });
  }

  async checkCoupon(coupon, pid = 0, cycle = 'monthly'){
    this.debug('Functions => checkCoupon');
    this.store.commit('loader', [true, "Aguarde", "Verificando Cupom..."]);
    
    const params = {'debug' : 'false',
                    'coupon': coupon,
                    'pid'   : pid,
                    'cycle' : cycle };

    await this.get('checkCoupon', params, 'plan.php').then((response) => {        
      this.debug(response);
      if (response.result == 'success'){
        this.store.commit('session', ['coupon', response.coupon]);
        this.store.commit('order', ['coupon', response.coupon]);
        this.store.commit('order', ['couponCycles', response.cycles]);
        this.store.commit('order', ['couponPackages', response.packages]);
        this.store.commit('order', ['couponFreeDays', response.freedays]);
        this.store.commit('order', ['couponType', response.type]);
        this.store.commit('order', ['couponValue', response.value]);

        let couponText;
        if (response.type == "Free Setup") 
          couponText = "+" + this.currencyFormat(response.value) + " dias grátis";
        
        if (response.type == "Percentage") {
          if (response.cycles.includes('monthly') && response.cycles.includes('annually'))
            couponText = this.currencyFormat(response.value) + "% de desconto no primeiro mês ou em pagamentos anuais";
          else if (response.cycles.includes('monthly'))
            couponText = this.currencyFormat(response.value) + "% de desconto no primeiro mês";
          else if (response.cycles.includes('annually'))
            couponText = this.currencyFormat(response.value) + "% de desconto em pagamentos anuais";
        }

        if (response.type == "Fixed Amount") {
          if (response.cycles.includes('monthly') && response.cycles.includes('annually'))
            couponText = "R$" + this.currencyFormat(response.value,2) + " de desconto no primeiro mês ou em pagamentos anuais";
          else if (response.cycles.includes('monthly'))
            couponText = "R$" + this.currencyFormat(response.value,2) + " de desconto no primeiro mês";
          else if (response.cycles.includes('annually'))
            couponText = "R$" + this.currencyFormat(response.value,2) + " de desconto em pagamentos anuais";
        }

        if (response.type == "Price Override") {
          if (response.cycles.includes('monthly') && response.cycles.includes('annually'))
            couponText = "Desconto exclusivo no primeiro mês ou em pagamentos anuais";
          else if (response.cycles.includes('monthly'))
            couponText = "Desconto exclusivo no primeiro mês";
          else if (response.cycles.includes('annually'))
            couponText = "Desconto exclusivo em pagamentos anuais";
        }

        this.store.commit('order', ['couponText', couponText]);
      }
      else this.removeCoupon();

      this.store.commit('loader', []);
      });

  }

  async removeCoupon(){    
    this.store.commit('session', ['coupon', '']);
    this.store.commit('order', ['coupon', '']);
    this.store.commit('order', ['couponCycles', '']);
    this.store.commit('order', ['couponPackages', '']);
    this.store.commit('order', ['couponFreeDays', 0]);
    this.store.commit('order', ['couponType', '']);
    this.store.commit('order', ['couponValue', -1]);
    this.store.commit('order', ['couponText', '']);
    this.store.commit('order', ['totalDays', 0]);
  }


  //LOGGING SYSTEM
  //0 = Warning - Falhas possivelmente de usabilidade que precisam ser logadas para análise futura.
  //1 = Erro - Falhas possivelmente do processo. Precisam de ação imediata do suporte.
  //2 = Fatal - Falhas críticas que impedem cliente de concluir o pedido. Precisam de ação imediata do suporte e comercial.
  async addLog(route, step, action, msg, level = 0){    
    this.debug('Functions => addLog: ');

    const errorlevel = ['warning', 'error', 'fatal'];
    
    const requestHeaders = {headers: { 'action': 'trackLog'} };
    const params = {'route'  : route,
                    'step'   : step,
                    'action' : action,
                    'msg'    : msg,
                    'session': this.store.state.session.id,
                    'client' : this.store.state.client.firstName + " " + this.store.state.client.lastName,
                    'email'  : this.store.state.client.email,
                    'phone'  : this.store.state.client.phone,
                    'level'  : errorlevel[level] };

    try {
      const request = await this.logger.post('/ist_tracking.php', qs.stringify(params), requestHeaders);
      this.debug(request);

      const params2 = { 'id'         : this.store.state.session.id,
                        'email'      : this.store.state.client.email,
                        'errorlevel' : errorlevel[level],
                        'errormsg'   : msg };

      this.addTrack(params2);
    }
    catch (error) {
      this.debug('ERROR: ' + error);      
    }
  }

  //TRACK SYSTEM
  async addTrack(params){    
    this.debug('Functions => addTrack: ');
    this.debug(params);

    const requestHeaders = {headers: { 'action': 'trackActivation'} };

    try {
      await this.tracking.post('/ist_tracking.php', qs.stringify(params), requestHeaders).then((response) => {        
        this.debug(response);
        this.store.commit('session', ['id', response.data.id]);
        this.saveCookie('session');
      })
    }
    catch (error) {
      this.debug('ERROR: ' + error);      
    }
  }

  //INFO
  showInfo(msg, type = 'info', timout = 7000){
    this.store.commit('info', [msg, type]);
    setTimeout(() => this.closeInfo(msg), timout);
  }

  closeInfo(msg){
    if (!msg || this.store.state.info.msg == msg)
      this.store.commit('info', []);
  }

  dateParse(date) {  
    try{  
      var day  = date.split("/")[0];
      var month  = date.split("/")[1];
      var year  = date.split("/")[2];
    
      // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      return year + '-' + ("0"+month).slice(-2) + '-' + ("0"+day).slice(-2);
    } catch (error) {
      return "";
    }
  }

}

export default Functions;